var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAwesomeHandPointRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 27,
    viewBox: "0 0 36 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-hand-point-right",
    "data-name": "Icon awesome-hand-point-right",
    d: "M36,14.038a3.171,3.171,0,0,1-3.15,3.082H25.829a3.458,3.458,0,0,1-.443,4.988,3.221,3.221,0,0,1-1.157,4.382c.631,3.455-1.543,5.011-5.1,5.011-.193,0-.933-.014-1.125-.014-4.357.012-5.407-2.184-8.7-2.694a1.686,1.686,0,0,1-1.425-1.667V15.065h0a3.375,3.375,0,0,1,2-3.083c2.031-.914,6.709-3.448,7.561-5.437A3,3,0,0,1,20.25,4.5a3.377,3.377,0,0,1,3.1,4.7,9.557,9.557,0,0,1-1,1.752H32.85A3.222,3.222,0,0,1,36,14.038Zm-29.25.024v13.5A1.687,1.687,0,0,1,5.063,29.25H1.688A1.687,1.687,0,0,1,0,27.563v-13.5a1.687,1.687,0,0,1,1.688-1.687H5.063A1.687,1.687,0,0,1,6.75,14.063ZM4.781,25.875a1.406,1.406,0,1,0-1.406,1.406A1.406,1.406,0,0,0,4.781,25.875Z",
    transform: "translate(0 -4.5)",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeHandPointRight);
export default __webpack_public_path__ + "static/media/icon-awesome-hand-point-right.70a704baeb09f862ef5ce06076d2dc06.svg";
export { ForwardRef as ReactComponent };